module.exports = __webpack_public_path__ + "static/media/connector-upwards.65f813e6.svg";